import { render, staticRenderFns } from "./AssessmentRangeSectionView.vue?vue&type=template&id=449ddb1d&scoped=true"
import script from "./AssessmentRangeSectionView.vue?vue&type=script&lang=js"
export * from "./AssessmentRangeSectionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449ddb1d",
  null
  
)

export default component.exports